// extracted by mini-css-extract-plugin
export default {"container":"Card_container__K7EcC","tool-image":"Card_tool-image__do2S-","tool":"Card_tool__rfAA2","icon":"Card_icon__0D7+y"};